import React, { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { Box, SxProps, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default observer(function MainMenuSection({
  onClick,
  children,
  sx,
}: {
  onClick: () => void;
  children: React.ReactNode;
  sx?: SxProps;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const theme = useTheme();

  return (
    <Box
      sx={{
        'width': 1,
        'cursor': 'pointer',
        'py': sp.s20,
        'px': defaultSpacingPresets.sp.s70,

        '&:hover': {
          color: theme.palette.primary.main,
          bgcolor: 'customBackgrounds.elevation4',
        },
        ...sx,
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
});
